// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-view-dashboard-component .data-view-dashboard-component-header[data-v-1127fa4a]{height:50px;line-height:50px;border-bottom:1px solid #ddd;padding:0 10px}.data-view-dashboard-component .data-view-dashboard-component-header>.right-container[data-v-1127fa4a]{float:right}.data-view-dashboard-component .data-view-dashboard-component-main[data-v-1127fa4a]{position:relative}[data-v-1127fa4a] .vue-grid-item.vue-grid-placeholder{background:#99a9bf!important}", ""]);
// Exports
module.exports = exports;
